module.exports = __webpack_public_path__ + "media/images/undraw/reserve/web_search-b601289e45c9ceff6120a86b7a4582d9.png";